// src/UI/Icon/Icon.tsx
import React, { FC, CSSProperties, ComponentPropsWithoutRef } from "react";
import { StyledSvg } from "./styles.ts";

// Тип для SvgComponent
type SvgComponentType = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & { title?: string }
>;

interface IconProps extends ComponentPropsWithoutRef<"svg"> {
  SvgComponent: SvgComponentType; // Импортированный ReactComponent из .svg
  size?: number;                  // По умолчанию 24
  color?: string;                 // Цвет (необязательно)
  style?: CSSProperties;          // Инлайн-стиль
}

const Icon: FC<IconProps> = ({
  SvgComponent,
  size = 24,
  color,
  style,
  ...props
}) => {
  return (
    <StyledSvg
      as={SvgComponent}
      // Передаём именно `$width` / `$height`, а не width/height
      $width={size}
      $height={size}
      $color={color}
      style={style}
      {...props}
    />
  );
};

export default Icon;
